import React, { useContext, useEffect } from 'react';
import styles from './styles.module.css';
import Sessions from './Sessions';
import Packages from './Packages';
import Text from 'components/shared/Text';
import MobileContext from 'context/MobileContext';
const Training = ({
  profileDetails,
  loadUserPackages,
  userPackages,
  loadSessionsNew,
  isSessionsLoading,
  isPackagesLoading,
  sessions,
}) => {
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;
  const sessionMessage = 'Looks like you have no Sessions booked.';
  const userPackagesMessage = 'Looks like you have not purchased a Package.';


  // load Session and user Packages
  useEffect(() => {
    let data = {
      caId: profileDetails?.userID,
      pageIndex: 0,
      pageSize: 10,
    };
    if (profileDetails !== undefined) {
      loadSessionsNew(data);
      loadUserPackages(profileDetails?.userID);
    }
    // eslint-disable-next-line
  }, [profileDetails]);

  return (
    <>
      <div className={`${styles.body} ${mobClassName}`}>
        <>
          <Text className={styles.heading}>Personal Training</Text>
          <Sessions
            sessionMessage={sessionMessage}
            loadingSessions={isSessionsLoading}
            sessionData={sessions?.data}
          />
          <Packages
            userPackagesMessage={userPackagesMessage}
            userPackagesData={userPackages?.data}
            loadingPackages={isPackagesLoading}
            userPackages={userPackages}
          />
        </>
      </div>
    </>
  );
};

export default Training;
